var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _path75, _path76, _path77, _path78, _path79, _path80, _path81, _path82, _path83, _path84, _path85, _path86, _path87, _path88, _path89, _path90, _path91, _path92, _path93, _path94, _path95, _path96, _path97, _path98, _path99, _path100, _path101, _path102, _path103, _path104, _path105, _path106, _path107, _path108, _path109, _path110, _path111, _path112;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRegister(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 727,
    height: 845,
    viewBox: "0 0 727 845",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M579.39 119.18H424.46V348.37H579.39V119.18Z",
    fill: "#3EC1F3"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M379.07 119.18H424.46V348.37H322.7V175.55C322.7 160.6 328.639 146.262 339.21 135.69C349.782 125.119 364.12 119.18 379.07 119.18Z",
    fill: "#3EC1F3"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M370.83 303.45C383.251 303.45 393.32 292.445 393.32 278.87C393.32 265.295 383.251 254.29 370.83 254.29C358.409 254.29 348.34 265.295 348.34 278.87C348.34 292.445 358.409 303.45 370.83 303.45Z",
    fill: "#F4E6D8"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M402.46 279.4H339.2C339.198 285.683 341.068 291.824 344.571 297.039C348.075 302.254 353.053 306.307 358.87 308.68V316.68H382.79V308.68C388.607 306.307 393.585 302.254 397.089 297.039C400.592 291.824 402.462 285.683 402.46 279.4Z",
    fill: "#023527"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M321.53 218L422.53 177",
    stroke: "#023527",
    strokeWidth: 4,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M422.63 119.18V348.37",
    stroke: "#023527",
    strokeWidth: 4,
    strokeMiterlimit: 10
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M991.93 720.57V632.57L938.76 578.48H789.33L736.16 632.57V714.16H550.06V680.23C490.47 673.81 508.8 629.81 475.8 629.81H417.13C412.854 629.794 408.664 631.009 405.06 633.31L322.23 582.12H236.98L130.18 648.12H130.41V731.22L58.6799 775.55V851.64H1045.1V774.64L991.93 720.57Z",
    fill: "#F5EBDD"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M268 466.66C296 457.99 332 445.53 441.55 535.12C551.1 624.71 592.55 566.12 581.34 552.58C572.34 541.68 522.08 571.09 559.49 610.74C595.04 648.44 699.23 612.38 727.8 589.3C768.46 556.46 826.67 530.63 877.98 528.77",
    stroke: "#BEC120",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeDasharray: "12 12"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M343.79 648.14L236.98 582.14",
    stroke: "#BEC120",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M131.41 648.14H344.02V850.66",
    stroke: "#BEC120",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M127.66 851.04L128.66 732.22",
    stroke: "#BEC120",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M59.6799 775.57H127.43",
    stroke: "#BEC120",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M128.81 761.36H342.41",
    stroke: "#BEC120",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M343.79 648.14H393.63",
    stroke: "#BEC120",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M492.3 682.06H549.06",
    stroke: "#BEC120",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M418.25 631.64C385.25 631.64 403.58 675.64 343.99 682.06H492.53C432.91 675.65 451.25 631.64 418.25 631.64Z",
    stroke: "#BEC120",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M343.99 849.66V682.07H492.5V850.66",
    stroke: "#BEC120",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M492.3 849.66V730.65H733.87V850.66",
    stroke: "#BEC120",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M492.73 728.41L548.53 712.31",
    stroke: "#BEC120",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M733.87 715.15V730.65H492.3",
    stroke: "#BEC120",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M540.29 758.16H540.53C544.869 758.16 549.03 759.884 552.098 762.952C555.166 766.02 556.89 770.181 556.89 774.52V851.67H523.89V774.52C523.89 772.368 524.315 770.238 525.139 768.25C525.964 766.263 527.173 764.457 528.696 762.938C530.219 761.418 532.028 760.214 534.017 759.394C536.007 758.574 538.138 758.155 540.29 758.16Z",
    fill: "#BEC120"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M687.89 758.16H688.17C692.509 758.16 696.67 759.884 699.738 762.952C702.806 766.02 704.53 770.181 704.53 774.52V851.67H671.53V774.52C671.53 770.181 673.254 766.02 676.322 762.952C679.39 759.884 683.551 758.16 687.89 758.16Z",
    fill: "#BEC120"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M614.09 758.16H614.37C618.709 758.16 622.87 759.884 625.938 762.952C629.006 766.02 630.73 770.181 630.73 774.52V851.67H597.73V774.52C597.73 770.181 599.454 766.02 602.522 762.952C605.59 759.884 609.751 758.16 614.09 758.16Z",
    fill: "#BEC120"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M174.28 795.74H174.53C178.869 795.74 183.03 797.464 186.098 800.532C189.166 803.6 190.89 807.761 190.89 812.1V851.66H157.89V812.1C157.89 809.952 158.313 807.824 159.135 805.839C159.958 803.854 161.163 802.051 162.682 800.532C164.201 799.013 166.004 797.808 167.989 796.985C169.974 796.163 172.102 795.74 174.25 795.74H174.28Z",
    fill: "#BEC120"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M299.87 795.74H300.15C302.3 795.737 304.43 796.159 306.417 796.98C308.404 797.801 310.21 799.005 311.731 800.525C313.252 802.044 314.459 803.848 315.283 805.835C316.106 807.821 316.53 809.95 316.53 812.1V851.66H283.53V812.1C283.53 807.765 285.251 803.606 288.315 800.539C291.378 797.471 295.535 795.745 299.87 795.74Z",
    fill: "#BEC120"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M237.07 795.74H237.35C241.689 795.74 245.85 797.464 248.918 800.532C251.986 803.6 253.71 807.761 253.71 812.1V851.66H220.71V812.1C220.71 807.761 222.434 803.6 225.502 800.532C228.57 797.464 232.731 795.74 237.07 795.74Z",
    fill: "#BEC120"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M190.91 677.48H157.91V733.4H190.91V677.48Z",
    fill: "#BEC120"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M316.51 677.48H283.51V733.4H316.51V677.48Z",
    fill: "#BEC120"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M253.71 677.48H220.71V733.4H253.71V677.48Z",
    fill: "#BEC120"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M405.86 710.48H378.44V751.73H405.86V710.48Z",
    fill: "#BEC120"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M458.04 710.48H430.62V751.73H458.04V710.48Z",
    fill: "#BEC120"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M405.86 782.91H378.44V824.16H405.86V782.91Z",
    fill: "#BEC120"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M458.04 782.91H430.62V824.16H458.04V782.91Z",
    fill: "#BEC120"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M273.2 414.83C273.2 435.46 251.2 459.29 242.48 459.29C233.76 459.29 211.77 435.46 211.77 414.83C211.915 406.78 215.215 399.109 220.96 393.467C226.704 387.825 234.434 384.664 242.485 384.664C250.536 384.664 258.266 387.825 264.01 393.467C269.755 399.109 273.055 406.78 273.2 414.83Z",
    fill: "#BEC120"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M242.48 424.46C247.798 424.46 252.11 420.148 252.11 414.83C252.11 409.511 247.798 405.2 242.48 405.2C237.161 405.2 232.85 409.511 232.85 414.83C232.85 420.148 237.161 424.46 242.48 424.46Z",
    fill: "white"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M30.0699 851.66H87.8299C87.8299 835.72 74.9 819.58 58.95 819.58C43 819.58 30.0699 835.72 30.0699 851.66Z",
    fill: "#BEC120"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M0 851.66H42.91C42.91 839.82 33.3 827.83 21.46 827.83C9.61999 827.83 0 839.82 0 851.66Z",
    fill: "#BEC120"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M523.32 284C452.15 327.51 427.4 448.71 412.32 492.93C396.01 540.75 360.09 539.66 318.41 553.58C276.73 567.5 278.28 597.85 278.28 597.85C268.538 604.487 259.229 611.738 250.41 619.56L303.18 687C315.63 678.41 334.11 667.64 359.46 652.33C411.82 620.7 458.69 591 488.94 558C519.19 525 598.69 380.3 598.69 380.3L523.32 284Z",
    fill: "#023527"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M303.18 687L250.4 619.57C226.8 640.57 212.66 660.57 205.55 672.21L279.96 767.27C290.44 748.27 282.11 721.53 282.96 709.86C283.53 702.83 289.91 696.16 303.18 687Z",
    fill: "#30242A"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M199.77 682.69L272.93 776.16C275.746 773.615 278.113 770.613 279.93 767.28L205.53 672.22C203.423 675.604 201.5 679.099 199.77 682.69Z",
    fill: "#3EC1F3"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M276.12 691L290.29 698.89",
    stroke: "white",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M269.81 705.26L284.01 708.48",
    stroke: "white",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M295.15 624.72L269.87 644.48",
    stroke: "#3EC1F3",
    strokeWidth: 4,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M282.35 608.35L257.07 628.11",
    stroke: "#3EC1F3",
    strokeWidth: 4,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M307.95 641.09L282.67 660.85",
    stroke: "#3EC1F3",
    strokeWidth: 4,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M320.75 657.46L295.47 677.22",
    stroke: "#3EC1F3",
    strokeWidth: 4,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M275.99 598.72L331.46 669.68",
    stroke: "#3EC1F3",
    strokeWidth: 4,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M545.35 472.48C533.3 453.48 521.51 432.48 512.55 410.81",
    stroke: "#30242A",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M565.18 17.42C569.99 17.42 573.89 13.5204 573.89 8.71001C573.89 3.89961 569.99 0 565.18 0C560.37 0 556.47 3.89961 556.47 8.71001C556.47 13.5204 560.37 17.42 565.18 17.42Z",
    fill: "#023527"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M592.83 135.68L592.23 125.56C603.88 127.02 612.51 125.29 618.68 122.13L592.23 100.84C592.23 100.84 601.39 97.18 595.89 77.92L625.33 67.22C623.78 63.22 622.75 53.58 619.78 43.22L602.25 50.85C598.157 58.7035 592.288 65.4936 585.11 70.68C582.144 67.6129 578.832 64.9014 575.24 62.6C574.76 62.29 574.24 62 573.76 61.71H573.71C573.22 61.43 572.71 61.16 572.22 60.9H572.14C571.64 60.65 571.14 60.4 570.63 60.18L570.53 60C570.04 59.77 569.53 59.57 569.02 59.37H568.88C568.37 59.19 567.88 59.02 567.36 58.86H567.19C566.69 58.71 566.19 58.58 565.67 58.47H565.49C564.98 58.36 564.49 58.28 563.97 58.22H563.77C563.27 58.17 562.77 58.14 562.26 58.13C557.89 58.07 553.56 59.85 549.95 64.9C547.795 67.8278 546.625 71.3645 546.61 75C546.68 85.75 556.68 96 565.61 99C558.55 113.89 535.74 123.18 526.99 126.27C527.27 129.68 527.54 132.85 527.78 135.68H592.83Z",
    fill: "#EAA58B"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M770.77 197.1C766.63 197.1 764.63 193.74 766.3 189.6L780.3 155.03L780.19 154.93L780.43 154.7C784.3 151.064 787.902 147.154 791.21 143C797.53 134.95 799.43 129.1 797.21 126.71C796.573 126.068 795.731 125.672 794.83 125.59C793.915 125.479 792.987 125.533 792.09 125.75C784.95 127.31 772.72 137.04 759.09 153.09C742.6 172.48 710.53 210.85 710.53 210.85C707.19 208.3 702.34 203.98 696.53 198.77L650.39 258.09C660.278 265.786 670.833 272.583 681.93 278.4C684.024 271.919 688.02 266.219 693.398 262.04C698.776 257.862 705.288 255.4 712.085 254.974C718.882 254.547 725.651 256.177 731.509 259.651C737.367 263.125 742.043 268.282 744.93 274.45C772.73 253.68 794.69 216.62 804.98 197.1H770.77Z",
    fill: "#EAA58B"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M617.9 148.51H603.8C630.69 164.71 618.8 195.27 618.8 195.27C618.8 195.27 655.53 220.94 630.73 252.11C632.55 250.195 634.092 248.034 635.31 245.69C635.31 245.69 641.23 251.13 650.31 258.09L696.45 198.77C675.02 179.65 640.23 148.51 617.9 148.51Z",
    fill: "#BEC120"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M476.72 198C476.72 198 449.72 220.51 467.97 250.65L477.58 196.65L476.72 198Z",
    fill: "#FF7235"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M527.74 135.68V136.01L528.9 135.68H527.74Z",
    fill: "#FF7235"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M565.53 99C556.64 96 546.64 85.78 546.53 75L523.62 85C524.51 97.62 525.8 113.53 526.87 126.27C535.7 123.18 558.53 113.89 565.53 99Z",
    fill: "#30242A"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M592.23 100.84L618.68 122.13C623.92 119.605 628.071 115.273 630.37 109.93C634.27 100.17 631.75 91.77 628.71 80.87C628.71 80.87 636.46 75.68 635.25 70.87C634.25 66.96 625.42 67.5 625.42 67.5L625.33 67.25L595.89 77.95C601.39 97.18 592.23 100.84 592.23 100.84Z",
    fill: "#30242A"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M585.11 70.6601C592.288 65.4737 598.157 58.6836 602.25 50.8301L575.25 62.5801C578.839 64.8821 582.148 67.5937 585.11 70.6601Z",
    fill: "#30242A"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "M570.63 60.09L570.53 60L570.63 60.09Z",
    fill: "#023527"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "M549.93 64.8C553.54 59.75 557.87 57.97 562.24 58.03H562.14C559.63 30.28 565.82 15.19 570.41 8.03003C566.009 8.67999 561.663 9.66281 557.41 10.97C525.6 20.6 521.95 51.97 522.84 70.63C523.01 74.37 523.33 79.35 523.72 84.97L546.63 74.97C546.619 71.3151 547.775 67.7521 549.93 64.8Z",
    fill: "#023527"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    d: "M573.71 61.6601C573.22 61.3801 572.71 61.1101 572.22 60.8501C572.73 61.1101 573.22 61.3801 573.71 61.6601Z",
    fill: "#3EC1F3"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    d: "M575.24 62.5799C574.76 62.2699 574.24 61.9799 573.76 61.6899C574.26 61.9999 574.76 62.2699 575.24 62.5799Z",
    fill: "#3EC1F3"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    d: "M567.17 58.8099C566.67 58.6599 566.17 58.5299 565.65 58.4199C566.16 58.5299 566.67 58.6599 567.17 58.8099Z",
    fill: "#3EC1F3"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    d: "M572.14 60.8101C571.64 60.5601 571.14 60.3101 570.63 60.0901C571.14 60.3101 571.64 60.5601 572.14 60.8101Z",
    fill: "#3EC1F3"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    d: "M563.75 58.1199C563.25 58.0699 562.75 58.0399 562.24 58.0299C562.74 57.9999 563.25 58.0699 563.75 58.1199Z",
    fill: "#3EC1F3"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    d: "M565.47 58.3899C564.96 58.2799 564.47 58.1999 563.95 58.1399C564.46 58.1999 564.96 58.2799 565.47 58.3899Z",
    fill: "#3EC1F3"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    d: "M568.86 59.3601C568.35 59.1801 567.86 59.0101 567.34 58.8501C567.85 59.0001 568.35 59.1801 568.86 59.3601Z",
    fill: "#3EC1F3"
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    d: "M570.53 60.0001C570.04 59.7701 569.53 59.5701 569.02 59.3701C569.53 59.6101 570.02 59.8101 570.53 60.0001Z",
    fill: "#3EC1F3"
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    d: "M562.14 58H562.24C562.74 58 563.24 58 563.75 58.09H563.95C564.46 58.15 564.95 58.23 565.47 58.34H565.65C566.16 58.45 566.65 58.58 567.17 58.73H567.34C567.85 58.89 568.34 59.06 568.86 59.24H569C569.51 59.44 570 59.64 570.51 59.87L570.63 59.92C571.14 60.14 571.63 60.39 572.14 60.64H572.22C572.73 60.9 573.22 61.17 573.71 61.45H573.76C574.26 61.74 574.76 62.03 575.24 62.34L602.24 50.59L619.77 42.96C614.42 24.3 602.77 3.22 570.4 7.82C565.82 15.18 559.63 30.27 562.14 58Z",
    fill: "#3EC1F3"
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    d: "M714.15 254.86C706.969 254.862 699.974 257.142 694.172 261.372C688.37 265.602 684.059 271.564 681.86 278.4C696.58 285.88 712.15 290.48 724.24 286.03C731.646 283.179 738.603 279.279 744.9 274.45C742.172 268.595 737.829 263.641 732.382 260.171C726.934 256.7 720.609 254.858 714.15 254.86Z",
    fill: "#CA7358"
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    d: "M622.53 311.24C655.53 289.69 632.53 253 630.73 252.11C655.48 220.94 618.81 195.27 618.81 195.27C618.81 195.27 630.69 164.71 603.81 148.51H593.59L592.83 135.68H528.93L527.77 136.01L528.85 148.51H508.23L477.58 196.66L467.97 250.66L468.46 251.47C468.133 252.077 467.8 252.687 467.46 253.3C461.26 265.5 460.35 275.88 461.94 284.3C465.25 301.91 479.43 311.19 479.43 311.19H622.53V311.24Z",
    fill: "#FF7235"
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    d: "M479.47 327.31H622.48V314.45V311.24H479.47V314.45V327.31Z",
    fill: "#30242A"
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    d: "M464.53 195.27H618.81",
    stroke: "#A15842",
    strokeWidth: 4,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    d: "M468.21 252.11H631.53",
    stroke: "#A15842",
    strokeWidth: 4,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    d: "M595.89 154.93L595.55 149.51",
    stroke: "#A15842",
    strokeWidth: 4,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    d: "M578.47 152.18L577.56 137.51",
    stroke: "#A15842",
    strokeWidth: 4,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    d: "M564.72 152.18L563.81 137.51",
    stroke: "#A15842",
    strokeWidth: 4,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    d: "M550.97 152.18L550.06 137.51",
    stroke: "#A15842",
    strokeWidth: 4,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    d: "M708.61 210.08L697.65 223.69",
    stroke: "#A15842",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    d: "M579.39 124.68C583.444 126.098 587.643 127.06 591.91 127.55",
    stroke: "#A15842",
    strokeWidth: 4,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    d: "M642.65 34.8401L581.23 62.3401",
    stroke: "#30242A",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    d: "M622.92 92.2C621.08 92.69 615.06 91.68 614.07 86.51",
    stroke: "black",
    strokeWidth: 4,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    d: "M613.45 66.0499C615.085 66.0499 616.41 64.7246 616.41 63.0899C616.41 61.4551 615.085 60.1299 613.45 60.1299C611.815 60.1299 610.49 61.4551 610.49 63.0899C610.49 64.7246 611.815 66.0499 613.45 66.0499Z",
    fill: "#30242A"
  })), _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    d: "M562.64 76.52L573.39 83.36",
    stroke: "#A15842",
    strokeWidth: 4,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    d: "M585.81 68.76L597.73 77.92",
    stroke: "#30242A",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    d: "M562.89 99.9299L594.98 100.84",
    stroke: "#30242A",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    d: "M687.53 314.45C691.177 314.45 694.674 315.899 697.253 318.477C699.831 321.056 701.28 324.553 701.28 328.2V328.2C701.285 330.009 700.934 331.802 700.245 333.476C699.557 335.149 698.545 336.67 697.268 337.952C695.99 339.234 694.473 340.251 692.802 340.946C691.131 341.64 689.34 341.999 687.53 342",
    stroke: "#FF7235",
    strokeWidth: 4,
    strokeMiterlimit: 10
  })), _path87 || (_path87 = /*#__PURE__*/React.createElement("path", {
    d: "M706.82 314.45C710.46 314.461 713.947 315.914 716.517 318.491C719.087 321.069 720.53 324.56 720.53 328.2C720.54 331.848 719.102 335.35 716.531 337.938C713.961 340.526 710.467 341.987 706.82 342",
    stroke: "#FF7235",
    strokeWidth: 4,
    strokeMiterlimit: 10
  })), _path88 || (_path88 = /*#__PURE__*/React.createElement("path", {
    d: "M805.93 316.28H654.47C647.942 316.28 642.65 321.572 642.65 328.1V328.3C642.65 334.828 647.942 340.12 654.47 340.12H805.93C812.458 340.12 817.75 334.828 817.75 328.3V328.1C817.75 321.572 812.458 316.28 805.93 316.28Z",
    fill: "#30242A"
  })), _path89 || (_path89 = /*#__PURE__*/React.createElement("path", {
    d: "M831.332 824.408L740.105 316.882L716.641 321.1L807.868 828.626L831.332 824.408Z",
    fill: "#30242A"
  })), _path90 || (_path90 = /*#__PURE__*/React.createElement("path", {
    d: "M654.67 316.28H654.47C647.942 316.28 642.65 321.572 642.65 328.1V328.3C642.65 334.828 647.942 340.12 654.47 340.12H654.67C661.198 340.12 666.49 334.828 666.49 328.3V328.1C666.49 321.572 661.198 316.28 654.67 316.28Z",
    stroke: "#FF7235",
    strokeWidth: 4,
    strokeMiterlimit: 10
  })), _path91 || (_path91 = /*#__PURE__*/React.createElement("path", {
    d: "M819.58 827.83H484.97V851.67H819.58V827.83Z",
    fill: "#30242A"
  })), _path92 || (_path92 = /*#__PURE__*/React.createElement("path", {
    d: "M505.59 881C521.794 881 534.93 867.864 534.93 851.66C534.93 835.456 521.794 822.32 505.59 822.32C489.386 822.32 476.25 835.456 476.25 851.66C476.25 867.864 489.386 881 505.59 881Z",
    fill: "#30242A"
  })), _path93 || (_path93 = /*#__PURE__*/React.createElement("path", {
    d: "M505.59 862.66C511.665 862.66 516.59 857.735 516.59 851.66C516.59 845.585 511.665 840.66 505.59 840.66C499.515 840.66 494.59 845.585 494.59 851.66C494.59 857.735 499.515 862.66 505.59 862.66Z",
    fill: "#BEC120"
  })), _path94 || (_path94 = /*#__PURE__*/React.createElement("path", {
    d: "M551.43 851.66H459.76C459.938 839.621 464.845 828.135 473.422 819.685C481.998 811.234 493.555 806.497 505.595 806.497C517.635 806.497 529.192 811.234 537.769 819.685C546.345 828.135 551.252 839.621 551.43 851.66Z",
    fill: "#FF7235"
  })), _path95 || (_path95 = /*#__PURE__*/React.createElement("path", {
    d: "M596.17 748.07H681.91C682.91 733.07 685.75 712.13 689.24 683.37C696.6 622.64 702.12 567.43 694.76 523.27C687.4 479.11 622.48 327.27 622.48 327.27H500.21C490.61 410.12 570.79 504.33 596.31 543.46C623.91 585.79 600.91 613.39 586.19 654.79C571.47 696.19 596.31 713.68 596.31 713.68C595.549 725.129 595.502 736.615 596.17 748.07Z",
    fill: "#023527"
  })), _path96 || (_path96 = /*#__PURE__*/React.createElement("path", {
    d: "M610.03 816.83H730.75C722.22 796.83 696.06 786.94 687.4 779.06C682.07 774.22 680.83 764.78 681.91 748.06H596.17C598.04 780.06 605.17 803.89 610.03 816.83Z",
    fill: "#30242A"
  })), _path97 || (_path97 = /*#__PURE__*/React.createElement("path", {
    d: "M614.71 827.83H733.41C733.152 824.039 732.253 820.32 730.75 816.83H610.03C611.391 820.578 612.953 824.25 614.71 827.83Z",
    fill: "#3EC1F3"
  })), _path98 || (_path98 = /*#__PURE__*/React.createElement("path", {
    d: "M629.51 716.9V747",
    stroke: "#3EC1F3",
    strokeWidth: 4,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path99 || (_path99 = /*#__PURE__*/React.createElement("path", {
    d: "M608.73 716.9V747",
    stroke: "#3EC1F3",
    strokeWidth: 4,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path100 || (_path100 = /*#__PURE__*/React.createElement("path", {
    d: "M650.29 716.9V747",
    stroke: "#3EC1F3",
    strokeWidth: 4,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path101 || (_path101 = /*#__PURE__*/React.createElement("path", {
    d: "M671.07 716.9V747",
    stroke: "#3EC1F3",
    strokeWidth: 4,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path102 || (_path102 = /*#__PURE__*/React.createElement("path", {
    d: "M596.53 715.98H684.53",
    stroke: "#3EC1F3",
    strokeWidth: 4,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path103 || (_path103 = /*#__PURE__*/React.createElement("path", {
    d: "M651.78 398.44C648.78 391.02 645.92 383.84 643.17 377.09L598.17 369.19V369.35C597.281 374.411 598.439 379.619 601.388 383.827C604.338 388.035 608.839 390.9 613.9 391.79L651.78 398.44Z",
    fill: "#3EC1F3"
  })), _path104 || (_path104 = /*#__PURE__*/React.createElement("path", {
    d: "M668.32 772.82L682.53 767",
    stroke: "white",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path105 || (_path105 = /*#__PURE__*/React.createElement("path", {
    d: "M675.66 786.58L687.53 777",
    stroke: "white",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path106 || (_path106 = /*#__PURE__*/React.createElement("path", {
    d: "M528.97 148.51C528.97 148.51 561.83 198 552.81 245.69C546.39 279.61 469.38 309 424.46 319V292.44C424.46 292.44 517.97 269.53 528.97 228.27C535.64 203.27 508.8 148.51 508.8 148.51",
    fill: "#F5EBDD"
  })), _path107 || (_path107 = /*#__PURE__*/React.createElement("path", {
    d: "M746.24 309C740.74 295.24 723.32 280.58 703.15 273.24C664.39 259.15 570.22 279.66 570.22 279.66L556.11 249.53L486.68 283.53C496.68 303.04 508.68 319.44 520.94 330.78C525.114 325.611 530.715 321.783 537.047 319.771C543.379 317.759 550.163 317.652 556.555 319.463C562.947 321.274 568.666 324.923 573.002 329.958C577.337 334.992 580.097 341.19 580.94 347.78C619.33 344.78 661.79 327.23 673.83 316.4C673.83 316.4 681.16 322.82 689.41 323.73C689.41 326.48 676.58 363.15 699.5 354.9C699.5 354.9 705.91 363.15 715.08 353.99C715.08 353.99 721.5 363.15 730.67 354.9C730.67 354.9 735.67 358.03 742.58 350.32C750.82 341 753.26 326.49 746.24 309Z",
    fill: "#EAA58B"
  })), _path108 || (_path108 = /*#__PURE__*/React.createElement("path", {
    d: "M508.8 148.51H506.53C487.92 148.51 457.45 162.27 461.12 197.91C464.342 227.744 473.001 256.736 486.67 283.45L556.1 249.45L508.8 148.51Z",
    fill: "#BEC120"
  })), _path109 || (_path109 = /*#__PURE__*/React.createElement("path", {
    d: "M547.31 318.11C542.253 318.106 537.26 319.235 532.697 321.414C528.134 323.592 524.116 326.765 520.94 330.7C523.48 333.071 526.151 335.297 528.94 337.37C541.85 346.81 560.82 349.23 580.94 347.66C579.883 339.489 575.886 331.982 569.697 326.544C563.507 321.106 555.549 318.107 547.31 318.11Z",
    fill: "#CA7358"
  })), _path110 || (_path110 = /*#__PURE__*/React.createElement("path", {
    d: "M700.3 353.36C704.3 345.36 713.38 324.62 706.82 310.78",
    stroke: "#A15842",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path111 || (_path111 = /*#__PURE__*/React.createElement("path", {
    d: "M546.39 282.36L568 277.93",
    stroke: "#A15842",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path112 || (_path112 = /*#__PURE__*/React.createElement("path", {
    d: "M716.53 353C720.69 344.56 729.69 324.21 723.32 310.78",
    stroke: "#A15842",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRegister);
export default __webpack_public_path__ + "static/media/register.cd0ea769a2f5bfe529269dee9534679f.svg";
export { ForwardRef as ReactComponent };